import { NotificationInstance } from 'antd/es/notification/interface';
import { ArgsProps } from 'antd/es/notification';

import { ReactComponent as SuccessIcon } from '@Icons/additional/notification/success.svg';
import { ReactComponent as ErrorIcon } from '@Icons/additional/notification/error.svg';
import { ReactComponent as InfoIcon } from '@Icons/additional/notification/info.svg';
import { ReactComponent as WarningIcon } from '@Icons/additional/notification/warning.svg';
import { Notifications } from '@Types/common/Notifications';

// time for notification to disappear in seconds
const TIMEOUT = 3;

const useNotification = (api: NotificationInstance): Notifications => {
  const customNotification = {
    success: (config: ArgsProps) =>
      api.open({
        ...config,
        icon: <SuccessIcon />,
        className: 'trojan-notification-success',
        type: 'success',
        duration: TIMEOUT,
      }),
    error: (config: ArgsProps) =>
      api.open({
        ...config,
        icon: <ErrorIcon />,
        className: 'trojan-notification-error',
        type: 'error',
        duration: TIMEOUT,
      }),
    info: (config: ArgsProps) =>
      api.open({
        ...config,
        icon: <InfoIcon />,
        className: 'trojan-notification-info',
        type: 'info',
        duration: TIMEOUT,
      }),
    warning: (config: ArgsProps) =>
      api.open({
        ...config,
        icon: <WarningIcon />,
        className: 'trojan-notification-warning',
        type: 'warning',
        duration: TIMEOUT,
      }),
  };

  const saveSuccessNotification = (reqId: string): void => {
    customNotification.success({
      message: `Request No. ${reqId} has been Created! Kindly Submit it from the table actions!`,
    });
  };

  const submitSuccessNotification = (reqId: string): void => {
    customNotification.success({
      message: `Request No. ${reqId} has been Submitted!`,
    });
  };

  const editSuccessNotification = (reqId: string): void => {
    customNotification.success({
      message: `Request No. ${reqId} has been Updated! Kindly Submit it from the table actions!`,
    });
  };

  const deleteSuccessNotification = (reqId: string): void => {
    customNotification.error({
      message: `Request No. ${reqId} has been Deleted!`,
    });
  };

  const cancelSuccessNotification = (reqId: string): void => {
    customNotification.error({
      message: `Request No. ${reqId} has been Cancelled!`,
    });
  };

  const successNotification = (message: string): void => {
    customNotification.success({
      message,
    });
  };

  const errorNotification = (errorMessage?: string | object): void => {
    let message = 'Something went wrong';

    if (typeof errorMessage === 'string' && errorMessage) {
      message = errorMessage;
    }

    if (
      errorMessage &&
      typeof errorMessage === 'object' &&
      (errorMessage as Response)?.status === 401
    ) {
      message = '401 Unauthorized';
    }

    customNotification.error({
      message,
    });
  };

  const taskApprovedNotification = (): void => {
    customNotification.success({
      message: 'Task has been Approved!',
    });
  };

  const taskRejectedNotification = (): void => {
    customNotification.warning({
      message: 'Task has been Rejected!',
    });
  };

  const taskErrorNotification = (): void => {
    customNotification.error({
      message: 'Task approving/rejecting failed!',
    });
  };

  const taskIsAlreadyApprovedRejected = (): void => {
    customNotification.error({
      message: 'Task is Already Approved or Rejected!',
    });
  };

  return {
    saveSuccessNotification,
    submitSuccessNotification,
    editSuccessNotification,
    deleteSuccessNotification,
    cancelSuccessNotification,
    successNotification,
    errorNotification,
    taskApprovedNotification,
    taskRejectedNotification,
    taskErrorNotification,
    taskIsAlreadyApprovedRejected,
  };
};

export default useNotification;
